import type { DesignKitIconSize } from '../foundations/iconography.js'

export type ButtonTone = {
    backgroundClass: string
    borderClass: string
    textClass: string
}

export const ButtonDisabledBlue = '#b3d7ed'

export const ButtonPrimaryTone: ButtonTone = {
    backgroundClass: 'bg-ts-primary-main enabled:hover:bg-ts-primary-dark data-[active=true]:bg-ts-secondary-main',
    borderClass: 'border-ts-primary-main enabled:hover:border-ts-primary-dark data-[active=true]:border-ts-secondary-main',
    textClass: 'text-ts-text-reversed'
}

export const ButtonPrimaryDisabledTone: ButtonTone = {
    backgroundClass: 'bg-[#b3d7ed]',
    borderClass: 'border-[#b3d7ed]',
    textClass: 'text-ts-text-reversed'
}

export const ButtonSecondaryTone: ButtonTone = {
    backgroundClass: 'bg-ts-gray-000 enabled:hover:bg-ts-primary-main data-[active=true]:bg-ts-primary-dark',
    borderClass: 'border-ts-primary-main enabled:hover:border-ts-primary-main data-[active=true]:border-ts-primary-dark',
    textClass: 'text-ts-primary-main enabled:hover:text-ts-text-reversed data-[active=true]:text-ts-text-reversed'
}

export const ButtonBoxTone: ButtonTone = {
    backgroundClass: 'bg-ts-gray-000 enabled:hover:bg-ts-primary-main data-[active=true]:bg-ts-primary-dark',
    borderClass: 'border-ts-primary-main enabled:hover:border-ts-primary-main data-[active=true]:border-ts-primary-dark',
    textClass: 'text-ts-text-primary enabled:hover:text-ts-text-reversed data-[active=true]:text-ts-text-reversed'
}

export const ButtonSecondaryDisabledTone: ButtonTone = {
    backgroundClass: 'bg-ts-gray-000',
    borderClass: 'border-[#b3d7ed]',
    textClass: 'text-[#b3d7ed]'
}

export function getButtonIconSize(size: 'large' | 'small'): DesignKitIconSize {
    return size === 'large' ? 'm' : 's'
}
